import { ListItemBox } from "lib/@components/ListItemBox"
import { AssetOpenFiltersButton } from "./plugins/filtering/asset-open-filters-button"
import { AssetFileImporterButton } from "./plugins/excel-import/asset-file-importer-button"
import { SearchBoxUsingSearchParam } from "lib/@components/searchBoxUsingSearchParam"
import { Divider } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { Secure } from "lib/authorization/secure"
import { AssetTableSearchableTooltip } from "./assets-table-searchable-tooltip"
import { ColumnManagerButton } from "lib/@components/managed-columns/column-manager-button"

export function AssetsTableToolsRow() {
    const { isFilterOpen, handleFilterClick } = useBoundContext()
    return (
        <ListItemBox spacing={1} sx={{ "& *": { fontSize: 14 }, marginBottom: 4 }}>
            <Secure hide demand="manageAssetRegister">
                <AssetFileImporterButton title="Add Assets" />
            </Secure>
            <SearchBoxUsingSearchParam
                placeholder="Search Assets..."
                autoFocus
                variant="outlined"
                startAdornment={<Iconify icon="iconamoon:search" width="24px" height="24px" />}
                sx={{ flex: 1, mb: 1, py: 0, "& *": { fontSize: 14 } }}
                textFieldProps={{ inputProps: { sx: { py: 1, borderRadius: 1 } } }}
                aria-label="Search bar for assets"
            />
            <AssetTableSearchableTooltip />
            <ColumnManagerButton />
            <Divider orientation="vertical" flexItem />
            {!isFilterOpen && <AssetOpenFiltersButton handleClick={handleFilterClick} isOpen={isFilterOpen} />}
        </ListItemBox>
    )
}
